const shadows = {
  sm: '0 4px 14px rgba(8, 40, 74, 0.06)',
  md: '0 12px 30px rgba(8, 40, 74, 0.10)',
  lg: '0 24px 50px rgba(8, 40, 74, 0.16)',
  outline: '0 0 0 3px rgba(7, 95, 199, 0.55)',
  // Sombra de card del panel administrativo (adición, no sustituye sm/md/lg).
  adminCard: '0 2px 10px rgba(15, 39, 71, 0.05)',
};

export default shadows;
